import { gql } from '@apollo/client'

export const EDIT_GOAL_GROUP = gql`
  mutation EditGoalGroup(
    $data: CreateGoalGroupInput!
    $funderOrgId: Int!
    $goalGroupId: Int!
  ) {
    editGoalGroup(
      data: $data
      funderOrgId: $funderOrgId
      goalGroupId: $goalGroupId
    ) {
      id
      title
      description
      category
      startDate
      endDate
    }
  }
`
